import { render } from "./Tem025.vue?vue&type=template&id=28a3ae16&scoped=true"
import script from "./Tem025.vue?vue&type=script&lang=js"
export * from "./Tem025.vue?vue&type=script&lang=js"

import "./Tem025.vue?vue&type=style&index=0&id=28a3ae16&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28a3ae16"]])

export default __exports__